@if (placeholder) {
  <span class="is-visually-hidden">
    {{placeholder}}
  </span>
}

@if (name !== undefined) {
  <svg aria-hidden="true" focusable="false">
  <use [attr.xlink:href]="urlIcons + (checkIsCommon(name)
    ? 'commons'
    : brand
      ? 'icons_' + brand?.toLowerCase()
      : 'icons_' + configBrand?.toLowerCase()) + '/' + name +'.svg#' + name"
    />
  </svg>
}
